export default [
    "andrewstech",
    "mtgsquad",
    "thebotlynoob",
    "hackermondev",
    "phenax",
    "maskduck"
];